import { connect } from 'react-redux';
import { IUser } from '../../models';
import { IRootState } from '../../redux/state';
import AutoSequenceRoute from './AutoSequenceRoute';
import { getRoutes } from '../../redux/modules/route/routeSelectors';
import { bindActionCreators, Dispatch } from 'redux';
import {
  getReportDetails,
  getRouteOrders,
  loadRoutes,
  setSelectedAutoSeqRoute,
  setSelectedAutoSeqRouteOrder,
  setSelectedRoutePage,
} from '../../redux/modules/route/routeCreators';

function mapStateToProps(state: IRootState) {
  const routes = getRoutes(state);
  return {
    impersonatedUser: state.authentication.impersonatedUser,
    authentication: state.authentication as unknown as IUser,
    routes: routes,
    isLoading:
      state.route.isAutoSequenceLoading ||
      state.route.isRouteListLoading ||
      state.route.isAutoSequenceOrderLoading,
    routeOrders: state.route.routeOrders,
    reportDetails: state.route.reportDetails,
    selectedRoute: state.route.selectedAutoSeqRoute,
    selectedOrder: state.route.selectedAutoSeqOrder,
    selectedRoutePage: state.route.selectedRoutePage,
  };
}

function mapDispatchToProps(dispatch: Dispatch) {
  return {
    loadRoutes: bindActionCreators(loadRoutes, dispatch),
    getRouteOrders: bindActionCreators(getRouteOrders, dispatch),
    getReportDetails: bindActionCreators(getReportDetails, dispatch),
    setSelectedRoute: bindActionCreators(setSelectedAutoSeqRoute, dispatch),
    setSelectedOrder: bindActionCreators(
      setSelectedAutoSeqRouteOrder,
      dispatch
    ),
    setSelectedRoutePage: bindActionCreators(setSelectedRoutePage, dispatch),
  };
}

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
export default connect(mapStateToProps, mapDispatchToProps)(AutoSequenceRoute);
